<template>
    <div class="nav-bar">
        <router-link v-for="(menu, index) in navs[type]" :key="index" :to="menu.path"  :class="[menu.path == path?'active':'', 'inner']">{{menu.name}}</router-link>
    </div>
</template>

<script>
	export default{
        data () {
            return {
                navs: {
                    '0': [
                        {name: 'CMA2019', path: '/cma/finalist'},
                        {name: 'CMA2019评审顾问', path: '/cma/expert/2019'}, 
                        {name: 'CMA2018', path: '/cma/old/2018'},
                        {name: 'CMA2018评审顾问', path: '/cma/expert/2018'}, 
                        {name: 'CMA2017', path: '/cma/old/2017'},   
                        {name: 'CMA2017评审顾问', path: '/cma/expert/2017'}
                    ],
                    '1': [
                        {name: '介绍', path: '/cma/introduce'},
                        {name: '会员', path: '/cma/member'},
                        {name: '组织架构', path: '/cma/organization'},
                        {name: '联系我们', path: '/cma/contact'}	 
                    ],
                    '3':[
                        {name: 'CMA2019奖项规则', path: '/cma/2019'},
                        {name: 'CMA2019入围提名', path: '/cma/finalist'}
                    ],
                    '4':[
                        {name: 'CMA评选规则', path: '/cma/2020-2021'},
                    ]
                },
                path: '',
            }
        },
		props:['type'],
        created() {
            this.path = this.$route.fullPath;
            if( this.type == 4 ){
                this.getActivityList();
            }
        },
        methods:{
            getActivityList(){
                this.$axios.get('/awardpublic/activityList', {
                    params: {}
                }).then(response => {
                    const {code, data, message} = response.data
                    if(code !== 0) return this.$message.error(message);
                    const _navs = [];
                    data.map(item => {
                        _navs.push({
                          name: item.name,
                          path: "/cma/applyList?activityId="+item.id,  
                        })
                    })
                    this.navs[4] = _navs.concat(this.navs[4] );

                }, function() {
                    
                })
            }
        }
	}
</script>

<style lang="scss" scoped>
    .nav-bar{
        padding: 30px 0;

        .inner {
            display: inline-block;
            margin-right: 10px;
            padding: 0 20px;
            height: 40px;
            min-width: 110px;
            line-height: 40px;
            border: 1px solid #999999;
            border-radius: 23px;
            text-align: center;
            font-size: 14px;
            color: #181413;

            &.active {
                background: #AF804D;
                border: 1px solid #AF804D;
                color: #fff;
            }
        }
    }
</style>

